/*
 Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class WpApiService {
    constructor(config) {
        this.wpApiUrl = config.wpApiUrl;
    }

    async menuItems() {
        return await this.sendRequest("/wp-json/diode/menu");
    }

    async footerItems() {
        return await this.sendRequest("/wp-json/diode/footer");
    }

    async cguContent() {
        return await this.sendRequest("/wp-json/wp/v2/pages/528");
    }

    async sendRequest(path) {
        const response = await fetch(this.wpApiUrl + path);
        return await response.json();
    }
}
